const MuiInputLabel = {
  outlined: {}
};

export default MuiInputLabel;
